"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
exports.__esModule = true;
var react_1 = require("react");
var isFunction_1 = __importDefault(require("../shared/isFunction"));
var isDevelopment_1 = __importDefault(require("../shared/isDevelopment"));
var useMemoizedFn = function useMemoizedFn(fn) {
  if (isDevelopment_1["default"]) {
    if (!(0, isFunction_1["default"])(fn)) {
      console.error("useMemoizedFn expected parameter is a function, got ".concat(_typeof(fn)));
    }
  }
  var fnRef = (0, react_1.useRef)(fn);
  fnRef.current = (0, react_1.useMemo)(function () {
    return fn;
  }, [fn]);
  var memoizedFn = (0, react_1.useRef)();
  if (!memoizedFn.current) {
    memoizedFn.current = function () {
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      return fnRef.current.apply(this, args);
    };
  }
  return memoizedFn.current;
};
exports["default"] = useMemoizedFn;